var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enabled)?_c('div',{staticClass:"wrapper--custom-loading"},[_c('LadRotateSquare2'),_vm._v(" "),_c('div',{staticClass:"random-text"},[_c('p',[_vm._v(_vm._s(_vm.$t(`${_vm.base}.${_vm.source}.${_vm.currentKey}`)))])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }